import { render, staticRenderFns } from "./NurseDashboard.vue?vue&type=template&id=fc3fa51e&scoped=true&"
import script from "./NurseDashboard.vue?vue&type=script&lang=js&"
export * from "./NurseDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc3fa51e",
  null
  
)

export default component.exports